import { useContext } from "react";
import { AuthManagerContext } from "../contexts/AuthManager";
import { useGetIsWorkerProfileComplete } from "./use-get-is-worker-profile-complete";

export const usePostOnboardingData = () => {
    const { user } = useContext(AuthManagerContext);
    const getIsWorkerProfileComplete = useGetIsWorkerProfileComplete();

    return getIsWorkerProfileComplete(user);
};
